var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircusLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 116,
    viewBox: "0 0 154 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9984 92.81L54.2184 84.25C55.8584 81.45 56.7984 78.19 56.7984 74.7C56.7984 64.23 48.3184 55.75 37.8484 55.75C27.3784 55.75 18.8984 64.23 18.8984 74.7C18.8984 85.17 27.3784 93.65 37.8484 93.65C42.6684 93.65 47.0684 91.84 50.4184 88.88L57.9984 92.81Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5887 54.1297C96.3641 54.1297 104.289 46.2052 104.289 36.4297C104.289 26.6543 96.3641 18.7297 86.5887 18.7297C76.8132 18.7297 68.8887 26.6543 68.8887 36.4297C68.8887 46.2052 76.8132 54.1297 86.5887 54.1297Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4383 51.6598C96.2137 51.6598 104.138 43.7352 104.138 33.9598C104.138 24.1843 96.2137 16.2598 86.4383 16.2598C76.6628 16.2598 68.7383 24.1843 68.7383 33.9598C68.7383 43.7352 76.6628 51.6598 86.4383 51.6598Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5977 40.4298C88.7977 41.4898 94.6777 37.3298 95.7377 31.1198",
    stroke: "#FFA940",
    strokeWidth: 1.0994,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9889 32.9297C78.6019 32.9297 79.0989 32.4328 79.0989 31.8197C79.0989 31.2067 78.6019 30.7097 77.9889 30.7097C77.3759 30.7097 76.8789 31.2067 76.8789 31.8197C76.8789 32.4328 77.3759 32.9297 77.9889 32.9297Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0983 24.4297C89.7113 24.4297 90.2083 23.9328 90.2083 23.3197C90.2083 22.7067 89.7113 22.2097 89.0983 22.2097C88.4852 22.2097 87.9883 22.7067 87.9883 23.3197C87.9883 23.9328 88.4852 24.4297 89.0983 24.4297Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.279 12.6609C128.949 12.6609 128.609 12.5309 128.349 12.2809C127.839 11.7709 127.839 10.9409 128.349 10.4309L130.749 8.03094C131.259 7.52094 132.089 7.52094 132.599 8.03094C133.109 8.54094 133.109 9.37094 132.599 9.88094L130.199 12.2809C129.949 12.5309 129.609 12.6609 129.279 12.6609Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.819 88.9609C117.309 106.511 100.269 117.871 82.7188 114.361",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.549 76.1297C102.909 77.1197 104.499 77.7397 106.119 78.1997C109.839 79.2497 113.889 79.4597 117.529 78.1497C121.169 76.8397 124.309 73.8697 125.219 70.1097C126.129 66.3497 124.419 61.9597 120.939 60.2797C118.909 59.3097 116.529 59.2897 114.349 59.8497C113.269 60.1197 112.209 60.5497 111.369 61.2797C108.749 63.5897 109.619 68.2397 112.349 70.4197C115.079 72.5997 118.899 72.7997 122.349 72.2997C125.469 71.8397 128.699 70.7697 130.699 68.3297C131.729 67.0697 132.369 65.5397 132.819 63.9697C133.819 60.5197 133.949 56.7297 132.619 53.3897C131.429 50.4097 128.959 47.8597 125.909 46.9297",
    stroke: "#FFA940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.268 45.7697L126.208 47.0097L127.438 49.0597L126.048 48.7097L124.818 46.6597L126.868 45.4297L128.268 45.7697Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.02 75.3845L139.291 79.2695L143.176 85.9984L149.905 82.1134L146.02 75.3845Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15906 103.279L0.289062 111.709L8.01906 108.249L1.15906 103.279Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9984 35.06C28.6476 35.06 34.8484 28.8591 34.8484 21.21C34.8484 13.5608 28.6476 7.35999 20.9984 7.35999C13.3493 7.35999 7.14844 13.5608 7.14844 21.21C7.14844 28.8591 13.3493 35.06 20.9984 35.06Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7094 34.7C26.3585 34.7 32.5594 28.4991 32.5594 20.85C32.5594 13.2009 26.3585 7 18.7094 7C11.0602 7 4.85938 13.2009 4.85938 20.85C4.85938 28.4991 11.0602 34.7 18.7094 34.7Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0784 14.66C27.7484 17.24 22.4284 26.67 22.4284 26.67C22.4284 26.67 12.0684 24.67 12.2184 20.14C12.3884 14.66 18.1484 17.4 18.1484 17.4C18.1484 17.4 19.8284 11.67 24.0784 14.66Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82031 24.62C9.76031 30.01 15.6903 32.79 21.0803 30.85",
    stroke: "white",
    strokeWidth: 0.6744,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5 36C151.538 36 154 33.5376 154 30.5C154 27.4624 151.538 25 148.5 25C145.462 25 143 27.4624 143 30.5C143 33.5376 145.462 36 148.5 36Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 13C66.0899 13 69 10.0899 69 6.5C69 2.91015 66.0899 0 62.5 0C58.9101 0 56 2.91015 56 6.5C56 10.0899 58.9101 13 62.5 13Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5 86C87.0899 86 90 83.0899 90 79.5C90 75.9101 87.0899 73 83.5 73C79.9101 73 77 75.9101 77 79.5C77 83.0899 79.9101 86 83.5 86Z",
    fill: "#FF922B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircusLeftImage);
export default __webpack_public_path__ + "static/media/circusLeftImage.8d72beff665aa609824a2b07276ef3c8.svg";
export { ForwardRef as ReactComponent };